import type { SvgComponent } from '@/types/SvgComponent';

export const YouTubeLogo: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      <path
        d="M15.5 12L11 9V15L15.5 12Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 12.0001C2.75 14.8041 3.03781 16.4485 3.25719 17.2941C3.3152 17.5242 3.42694 17.7371 3.58322 17.9156C3.73951 18.094 3.93589 18.2329 4.15625 18.3207C7.29875 19.5329 12.5 19.5001 12.5 19.5001C12.5 19.5001 17.7012 19.5329 20.8438 18.3207C21.0648 18.2334 21.2619 18.0947 21.4189 17.9163C21.5759 17.7378 21.6882 17.5246 21.7466 17.2941C21.9659 16.4504 22.2537 14.8041 22.2537 12.0001C22.2537 9.19602 21.9659 7.55165 21.7466 6.70602C21.6888 6.47477 21.5768 6.26059 21.4198 6.08126C21.2628 5.90192 21.0653 5.76257 20.8438 5.67477C17.7012 4.46727 12.5 4.50009 12.5 4.50009C12.5 4.50009 7.29875 4.46727 4.15625 5.67946C3.93466 5.76726 3.73718 5.9066 3.58017 6.08594C3.42317 6.26528 3.31116 6.47945 3.25344 6.71071C3.03781 7.55071 2.75 9.19602 2.75 12.0001Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
